export const customersIt: Record<string, string> = {
  'customers.title': 'Clienti',
  'customers.selectCustomer': 'Seleziona Cliente',
  'customers.customer': 'Cliente',
  'customers.searchPlaceholder': 'Cerca clienti...',
  'customers.firstName': 'Nome',
  'customers.firstNamePlaceholder': 'Inserisci nome',
  'customers.lastName': 'Cognome',
  'customers.lastNamePlaceholder': 'Inserisci cognome',
  'customers.email': 'Email',
  'customers.emailPlaceholder': 'Inserisci indirizzo email',
  'customers.phone': 'Telefono',
  'customers.subtitle': 'Gestisci il tuo database clienti',
  'customers.table.name': 'Nome',
  'customers.table.contact': 'Contatto',
  'customers.table.weddingDate': 'Data Matrimonio',
  'customers.table.partner': 'Partner',
  'customers.table.source': 'Fonte',
  'customers.table.created': 'Creato',
  'customers.table.lastAppointment': 'Ultimo Appuntamento',
  'customers.empty.noResults': 'Nessun cliente corrisponde ai filtri',
  'customers.empty.noCustomers': 'Nessun cliente ancora',
  'customers.empty.noCustomersDesc': 'Aggiungi il tuo primo cliente per iniziare.',
  'customers.filters.title': 'Filtri',
  'customers.filters.referral': 'Fonte Referral',
  'customers.filters.weddingDate': 'Data Matrimonio',
  'customers.filters.createdDate': 'Data Creazione',
  'customers.filters.from': 'Da',
  'customers.filters.to': 'A',
  'customers.filters.clearAll': 'Cancella tutto',
  'customers.filters.apply': 'Applica',
  'customers.filters.appointments': 'Appuntamenti',
  'customers.filters.noFilter': 'Nessun filtro',
  'customers.filters.hasAnyAppointment': 'Ha almeno un appuntamento',
  'customers.filters.hasAppointmentType': 'Ha appuntamento {type}',
  'customers.filters.orders': 'Ordini',
  'customers.filters.hasAtLeastOneOrder': 'Ha almeno un ordine',
  'customers.filters.hasNoOrder': 'Non ha ordini',
  'customers.filters.contact': 'Contatto',
  'customers.filters.hasEmail': 'Ha Email',
  'customers.filters.hasPhone': 'Ha Telefono',
  'customers.filters.missingContact': 'Contatto Mancante',
  'customers.filters.hasPortalAccount': 'Ha Account Portale',
  'customers.filters.noWeddingDate': 'Senza Data Matrimonio',
  'customers.source.facebook': 'Facebook',
  'customers.source.unknown': 'Sconosciuto',
  'customers.source.Form': 'Modulo',
  'customers.source.other': 'Altro',
  'customers.source.walkIn': 'Di persona',
  'customers.source.instagram': 'Instagram',
  'customers.source.website': 'Sito web',
  'customers.source.venue': 'Location',
  'customers.source.friend': 'Amico/a',
  'customers.source.family': 'Famiglia',
  'customers.source.manual': 'Manuale',
  'customers.createTitle': 'Crea Nuovo Cliente',
  'customers.form.firstName': 'Nome',
  'customers.form.lastName': 'Cognome',
  'customers.form.email': 'Email',
  'customers.form.phone': 'Telefono',
  'customers.form.partnerName': 'Nome Partner',
  'customers.form.weddingDate': 'Data Matrimonio',
  'customers.form.referralSource': 'Fonte',
  'customers.form.notes': 'Note',
  'customers.form.selectSource': 'Seleziona fonte',
  'customers.form.createButton': 'Crea Cliente',
  'customers.form.createdSuccess': 'Cliente creato con successo',
  'customers.form.createdError': 'Errore nella creazione del cliente',
  'customers.sort.recentlyCreated': 'Creati di Recente',
  'customers.sort.oldestFirst': 'Più Vecchi',
  'customers.sort.nameAZ': 'Nome A-Z',
  'customers.sort.nameZA': 'Nome Z-A',
  'customers.sort.weddingSoonest': 'Matrimonio Più Vicino',
  'customers.sort.weddingLatest': 'Matrimonio Più Lontano',
  'customers.stats.total': 'Clienti Totali',
  'customers.stats.upcomingWeddings': 'Matrimoni in Arrivo',
  'customers.stats.recentlyAdded': 'Aggiunti di Recente (Ultimi 30 Giorni)',
  'customers.stats.missingContact': 'Contatto Mancante',
  'customers.stats.weddingsThisMonth': 'Matrimoni Questo Mese',
  'customers.stats.noWeddingDate': 'Senza Data Matrimonio',
  'customers.stats.pastWeddingsNoOrder': 'Matrimoni Passati (Senza Ordine)',
  'customers.stats.show': 'Mostra statistiche',
  'customers.stats.hide': 'Nascondi statistiche',
  'customers.pagination.showing': 'Mostrando {from}-{to} di {total} clienti',
  'customers.columns.toggle': 'Colonne',
  'customers.noCustomersFound': 'Nessun cliente trovato',

  // Legacy customer keys
  'create_new_customer': 'Crea Nuovo Cliente',
  'first_name_required': 'Nome*',
  'last_name_required': 'Cognome*',
  'first_name_placeholder': 'Nome',
  'last_name_placeholder': 'Cognome',
  'email_placeholder': 'email@esempio.com',
  'phone_number_placeholder': 'Numero di telefono',
  'partner_name': 'Nome Partner',
  'partner_name_placeholder': 'Nome del partner',
  'wedding_date': 'Data Matrimonio',
  'referral_source': 'Fonte',
  'select_source': 'Seleziona fonte',
  'all_referral_sources': 'Tutte le Fonti',
  'all_sources': 'Tutte le Fonti',
  'website': 'Sito Web',
  'instagram': 'Instagram',
  'facebook': 'Facebook',
  'friend_referral': 'Referenza Amico',
  'family_referral': 'Referenza Famiglia',
  'wedding_venue': 'Location Matrimonio',
  'walk_in': 'Di persona',
  'customer_created_successfully': 'Cliente creato con successo',
  'failed_to_create_customer': 'Impossibile creare il cliente',

  // CustomerProfile toasts
  'customers.toast.linkCopied': 'Link copiato negli appunti!',
  'customers.toast.loadError': 'Impossibile caricare i dati del cliente',
  'customers.toast.updated': 'Cliente aggiornato con successo',
  'customers.toast.updateError': 'Impossibile aggiornare il cliente',
  'customers.profile.notFound': 'Cliente non trovato',
  'customers.profile.backToCustomers': 'Torna ai clienti',
  'customers.profile.back': 'Indietro',
  'customers.profile.title': 'Profilo Cliente',
  'customers.profile.cancel': 'Annulla',
  'customers.profile.saveChanges': 'Salva modifiche',
  'customers.profile.qrCode': 'Codice QR',
  'customers.profile.portalQrTitle': 'Codice QR portale cliente',
  'customers.profile.weddingLabel': 'Matrimonio',
  'customers.profile.portalAccess': 'Accesso portale cliente',
  'customers.profile.directLink': 'Link diretto',
  'customers.profile.copyLink': 'Copia link',
  'customers.profile.print': 'Stampa',
  'customers.profile.download': 'Scarica',
  'customers.profile.qrHint': 'Fai scansionare questo codice QR al cliente per accedere al portale e completare l\'onboarding.',
  'customers.profile.tabs.overview': 'Panoramica',
  'customers.profile.tabs.overviewShort': 'Info',
  'customers.profile.tabs.wedding': 'Matrimonio',
  'customers.profile.tabs.weddingShort': 'Matr',
  'customers.profile.tabs.leads': 'Contatti',
  'customers.profile.tabs.leadsShort': 'Cont',
  'customers.profile.tabs.appointments': 'Appuntamenti',
  'customers.profile.tabs.appointmentsShort': 'Appt',
  'customers.profile.tabs.orders': 'Ordini',
  'customers.profile.tabs.ordersShort': 'Ord',
  'customers.profile.tabs.measurements': 'Misure',
  'customers.profile.tabs.measurementsShort': 'Mis',
  'customers.profile.tabs.files': 'File',
  'customers.profile.tabs.filesShort': 'File',
  'customers.profile.personalDetails': 'Dettagli personali',
  'customers.profile.name': 'Nome',
  'customers.profile.partner': 'Partner',
  'customers.profile.notesPlaceholder': 'Aggiungi note su questo cliente...',
  'customers.profile.noNotes': 'Nessuna nota ancora.',
  'customers.profile.noEventDetails': 'Nessun dettaglio evento ancora.',
  'customers.profile.noDressPreferences': 'Nessuna preferenza abito ancora.',
  'customers.profile.noDecisionInfo': 'Nessuna informazione decisionale ancora.',
  'customers.profile.crossSellInterests': 'Interessi cross-sell',
  'customers.profile.interested': 'Interessata',
  'customers.profile.notInterested': 'Non interessata',
  'customers.profile.scheduleAppointment': 'Pianifica appuntamento',
  'customers.profile.noAppointments': 'Nessun appuntamento pianificato.',
  'customers.profile.createOrder': 'Crea ordine',
  'customers.profile.orderNumber': 'Ordine #{orderNo}',
  'customers.profile.created': 'Creato',
  'customers.profile.due': 'Scadenza',
  'customers.profile.noOrders': 'Nessun ordine creato.',
  'customers.profile.addMeasurements': 'Aggiungi misure',
  'customers.profile.version': 'Versione {version}',
  'customers.profile.bust': 'Busto',
  'customers.profile.waist': 'Vita',
  'customers.profile.hips': 'Fianchi',
  'customers.profile.measuredBy': 'Misurato da',
  'customers.profile.noMeasurements': 'Nessuna misura registrata.',
  'customers.profile.filesDocuments': 'File e documenti',

  // Magic link
  'customers.magicLink.trigger': 'Invia Magic Link',
  'customers.magicLink.dialogTitle': 'Invia accesso al portale cliente',
  'customers.magicLink.dialogDescription': 'Invia un magic link sicuro per dare al cliente accesso immediato al suo portale bridal.',
  'customers.magicLink.successTitle': 'Magic Link inviato!',
  'customers.magicLink.successInfo': 'Il cliente riceverà un\'email con un link sicuro per accedere al portale. Il link scadrà tra {minutes} minuti.',
  'customers.magicLink.emailLabel': 'Email cliente',
  'customers.magicLink.emailPlaceholder': 'cliente@esempio.com',
  'customers.magicLink.expiryLabel': 'Scadenza link (minuti)',
  'customers.magicLink.sending': 'Invio in corso...',
  'customers.magicLink.emailInvalid': 'Inserisci un indirizzo email valido',
  'customers.magicLink.error.notFound': 'Cliente non trovato. Controlla l\'indirizzo email.',
  'customers.magicLink.error.sendFailed': 'Impossibile inviare il magic link. Riprova.',
  'customers.magicLink.error.unexpected': 'Si è verificato un errore imprevisto. Riprova.',
  'customers.magicLink.sent': 'Magic Link Inviato',
  'customers.magicLink.sentDescription': 'Link di accesso al portale inviato a {email}',

  // Realtime appointment notifications
  'customers.realtime.newAppointment': 'Nuovo Appuntamento',
  'customers.realtime.newAppointmentDesc': 'È stato creato un nuovo appuntamento',
  'customers.realtime.appointmentUpdated': 'Appuntamento Aggiornato',
  'customers.realtime.appointmentUpdatedDesc': 'Un appuntamento è stato modificato',
  'customers.realtime.appointmentDeleted': 'Appuntamento Eliminato',
  'customers.realtime.appointmentDeletedDesc': 'Un appuntamento è stato rimosso',

  // Keyboard shortcuts
  'shortcuts.title': 'Scorciatoie da Tastiera',
  'shortcuts.closeModal': 'Chiudi modale/dialogo',
  'shortcuts.viewDetails': 'Visualizza dettagli appuntamento',
  'shortcuts.edit': 'Modifica appuntamento selezionato',
  'shortcuts.new': 'Crea nuovo appuntamento',
  'shortcuts.duplicate': 'Duplica appuntamento',
  'shortcuts.delete': 'Elimina appuntamento',
  'shortcuts.save': 'Salva modifiche',
  'shortcuts.navigateForward': 'Naviga tra gli elementi',
  'shortcuts.navigateBack': 'Naviga all\'indietro',
  'shortcuts.activate': 'Attiva pulsante/link',
  'shortcuts.category.general': 'Generale',
  'shortcuts.category.navigation': 'Navigazione',
  'shortcuts.category.actions': 'Azioni',
  'shortcuts.hint': 'La maggior parte delle scorciatoie funziona quando non si digita nei campi modulo. Usa Tab per navigare tra gli elementi interattivi e premi Spazio o Invio per attivarli.',
};
